import { fetchApi } from './fetchApi';
/**
 * Send a request to the Vend API and parse the response as JSON.
 */
export async function fetchApiJson(path, options = {}) {
    const response = await fetchApi(path, options);
    return response.json();
}
